import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CountdownModule } from 'ngx-countdown';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomepageComponent } from './homepage/homepage.component';
import { MenuComponent } from './menu/menu.component';
import { AboutComponent } from './about/about.component';
import { CareerComponent } from './career/career.component';
import { ContactComponent } from './contact/contact.component';
import { ProductListsComponent } from './products/product-lists/product-lists.component';
import { ProductDetailsComponent } from './products/product-details/product-details.component';
import { LoginComponent} from './userpages/login/login.component'; 
import { RegisterComponent } from './userpages/register/register.component';
import { ForgotPasswordComponent } from './userpages/forgot-password/forgot-password.component';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { OtherpageComponent } from './otherpages/otherpage/otherpage.component';
import { MyaccountComponent } from './my-account/myaccount/myaccount.component';
import { EditprofileComponent } from './my-account/editprofile/editprofile.component';
import { ChangepasswordComponent } from './my-account/changepassword/changepassword.component';
import { UserdashboardSidebarComponent } from './my-account/userdashboard-sidebar/userdashboard-sidebar.component';
import { VerifyregisterComponent } from './userpages/verifyregister/verifyregister.component';
import { UserForgotpasswordComponent } from './my-account/user-forgotpassword/user-forgotpassword.component';
import { MyaddressesComponent } from './my-account/myaddresses/myaddresses.component';
import { OrdersComponent } from './my-account/orders/orders.component';
import { TrackOrderComponent } from './my-account/track-order/track-order.component';
import { HeaderUserComponent } from './header-user/header-user.component';
import { EditAddressComponent } from './my-account/edit-address/edit-address.component';
import { UserheadingSectionComponent } from './my-account/userheading-section/userheading-section.component';
import { AddAddressComponent } from './my-account/add-address/add-address.component';
import { ProductSearchComponent } from './products/product-search/product-search.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { OrderDetailsComponent } from './my-account/order-details/order-details.component';
import { ResetPasswordComponent } from './userpages/reset-password/reset-password.component';
import { RefreshloaderComponent } from './shared/refreshloader/refreshloader.component';
import { SubcatsComponent } from './products/subcats/subcats.component';
import { OrdertrackDirective } from './shared/ordertrack.directive';
import { PaymentCancelComponent } from './payment-cancel/payment-cancel.component';
import { OngoingOrdersComponent } from './my-account/ongoing-orders/ongoing-orders.component';
import { OrderTrackComponent } from './order-track/order-track.component';
import { RewardpointsComponent } from './my-account/rewardpoints/rewardpoints.component';
import { RadioclickDirective } from './shared/radioclick.directive';
import { IngrdradioDirective } from './shared/ingrdradio.directive';
import { EditcartradioDirective } from './shared/editcartradio.directive';
import { AutocheckedDirective } from './shared/autochecked.directive';
import { EditcartingredientDirective } from './shared/editcartingredient.directive';
import { WishlistComponent } from './my-account/wishlist/wishlist.component';
import { ResFormComponent } from './res-form/res-form.component';
import { ShishaComponent } from './shisha/shisha.component';
import { GuestCheckoutComponent } from './guest-checkout/guest-checkout.component';
import { LimittoPipe } from './shared/limitto.pipe';
import { VariationbtnDirective } from './shared/variationbtn.directive';
import { SavedCardsComponent } from './my-account/saved-cards/saved-cards.component';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomepageComponent,
    MenuComponent,
    AboutComponent,
    CareerComponent,
    ContactComponent,
    ProductListsComponent,
    ProductDetailsComponent,
    RegisterComponent,
    LoginComponent,
    ForgotPasswordComponent,
    CartComponent,
    CheckoutComponent,
    OtherpageComponent,
    MyaccountComponent,
    EditprofileComponent,
    ChangepasswordComponent,
    UserdashboardSidebarComponent,
    VerifyregisterComponent,
    UserForgotpasswordComponent,
    MyaddressesComponent,
    OrdersComponent,
    TrackOrderComponent,
    HeaderUserComponent,
    EditAddressComponent,
    UserheadingSectionComponent,
    AddAddressComponent,
    ProductSearchComponent,
    ThankYouComponent,
    OrderDetailsComponent,
    ResetPasswordComponent,
    RefreshloaderComponent,
    SubcatsComponent,
    OrdertrackDirective,
    PaymentCancelComponent,
    OngoingOrdersComponent,
    OrderTrackComponent,
    RewardpointsComponent,
    RadioclickDirective,
    IngrdradioDirective,
    EditcartradioDirective,
    AutocheckedDirective,
    EditcartingredientDirective,
    WishlistComponent,
    ResFormComponent,
    ShishaComponent,
    GuestCheckoutComponent,
    LimittoPipe,
    VariationbtnDirective,
    SavedCardsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CountdownModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCsWc83B8PoHqGd0OqpTuYj-JuGtqimagI',
      //apiKey: 'AIzaSyBynwHIblFykI42WupXMsymd0UMr-vTaB0',
      libraries: ["places"]
    }),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  })
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }